// extracted by mini-css-extract-plugin
export default {"description":"CollectionSummary_description__-MvqT"};